import {
	ButtonGroup,
	Flex,
	FormControl,
	FormLabel,
	Input,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Select,
} from '@chakra-ui/react';
import { ButtonComponent } from 'components/buttons/ButtonComponent';
import { useGetActivityById } from 'pages/admin/capacity/productionActivity/hooks/useGetActivityById';
import { useGetResourceGroup } from 'pages/admin/capacity/resources/hooks/useGetResourceGroupList';
import { useEffect } from 'react';
import { useForm } from 'services/hooks/useForm';

import { useEditActivity } from '../../../productionActivity/hooks/useEditActivity';

export const EditActivity = props => {
	const { isOpen, onClose, idEdit } = props;

	const { form, onChange, setForm } = useForm({
		descricao: '',
		id: 0,
		grupo_recurso_id: 0,
	});
	const { mutate: getTopologyId } = useGetActivityById(setForm, idEdit);

	useEffect(() => {
		getTopologyId();
	}, []);

	const body = {
		descricao: form.descricao,
		grupo_recurso_id: form.grupo_recurso_id,
		id: form.id,
	};

	const { mutate } = useEditActivity(body, onClose);

	const createActivity = event => {
		event.preventDefault();
		mutate();
	};

	const { data: ResourceGroupData } = useGetResourceGroup();

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			size={'lg'}
			isCentered
		>
			<ModalOverlay />
			<ModalContent
				borderRadius={20}
				pt='20px'
			>
				<ModalHeader color='gray.700'>Editar Atividade</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<form onSubmit={createActivity}>
						<FormControl
							mr='5px'
							mb='20px'
							isRequired
						>
							<FormLabel mb='0'>Descrição</FormLabel>
							<Input
								data-test='input-descricao-cadastrar_atividade-modal-atividade'
								name='descricao'
								value={form.descricao}
								onChange={e => onChange(e)}
								h='44px'
								placeholder={'Embalar Pipeta'}
								borderRadius={10}
							/>
						</FormControl>

						<FormControl
							mr='5px'
							mb='20px'
							isRequired
						>
							<FormLabel mb='0'>Grupo de recurso</FormLabel>
							<Select
								data-test='select-grupo_de_recurso-cadastrar_atividade-modal-atividade'
								name='grupo_recurso_id'
								onChange={e => onChange(e)}
								placeholder='Selecione'
								h='44px'
								borderRadius={10}
							>
								{ResourceGroupData &&
									ResourceGroupData.map(resource => {
										return (
											<>
												<option
													selected={
														resource.id ===
														form.grupo_recurso_id
													}
													value={resource.id}
												>
													{
														resource.nome_grupo_recurso
													}
												</option>
											</>
										);
									})}
							</Select>
						</FormControl>

						<Flex
							justifyContent='end'
							mt={'44px'}
						>
							<ButtonGroup spacing={'24px'}>
								<ButtonComponent
									data-test={
										'button-cancelar-modal-atividade'
									}
									type={'ghost'}
									title={'Cancelar'}
									onClick={onClose}
								/>
								<ButtonComponent
									data-test={'button-salvar-modal-atividade'}
									type={'primary'}
									title={'Salvar'}
									action={'submit'}
								/>
							</ButtonGroup>
						</Flex>
					</form>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};
